module.exports = __webpack_public_path__ + "img/01-price-title.37cb3887.png";